import { mediaItems } from "@/mocks/homeData";

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            热门推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-xl mx-auto">
            精选平台最受欢迎的高清影视内容，每一部都值得用心观看
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[2/3] rounded-xl overflow-hidden mb-3 bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 rounded text-[10px] font-semibold bg-primary-500 text-background-50 font-label">
                    {item.quality}
                  </span>
                </div>
                <div className="absolute top-2 right-2">
                  <span className="text-[10px] font-medium text-foreground-100 bg-black/50 px-2 py-0.5 rounded">
                    {item.category}
                  </span>
                </div>
                <div className="absolute bottom-3 left-3 right-3">
                  <span className="text-[10px] text-foreground-200 block">
                    {item.duration}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
                    <i className="ri-play-fill text-2xl text-background-50"></i>
                  </div>
                </div>
              </div>
              <h3 className="text-xs font-medium text-foreground-800 line-clamp-2 leading-snug mb-1 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <span className="text-[11px] text-foreground-400">{item.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}